
import kontakt from '~/mixins/models/kontakt';
import formularmodal from '~/mixins/formularmodal';
export default {
  mixins: [kontakt, formularmodal],
  props: [],
  data() {
    return {
      modal: {
        event: 'formular::tankabrechnungen',
        titel: null,
        modelname: 'Tankabrechnung',
        model: 'tankabrechnungen'
      },
      model: null
    }
  },
  computed: {},
  watch: {},
  methods: {
    fillModel(model = null) {
      if (!model) model = {};
      let empty = {
        datum: this.$moment().format('YYYY-MM-DD')
      };
      this.model = this.$fillMissing(model, empty);
    },
  },

}
